import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TextWithShowMoreComponent, TooltipModule } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { PatientAlertV2, ProvisionalStatus } from '@ffd/api-client';
import { Store } from '@ngrx/store';
import { selectIsEaglesoftPms, selectProvisionalLocksEditing } from '@libs/store';
import { isLockedByProvisional } from '@libs/utils';
import { HealthHistoryItemIconComponent } from '../health-history-item-icon/health-history-item-icon.component';
import { HealthHistoryItemProvisionalStatusIconComponent } from '../health-history-item-provisional-status-icon/health-history-item-provisional-status-icon.component';
import { PatientAlertsDateIndicatorComponent } from '../patient-alerts-date-indicator/patient-alerts-date-indicator.component';

const DEFAULT_PATIENT_ALERT_LINE_CLAMP_ROWS = 8;

@Component({
  selector: 'lib-patient-alerts-item-details',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TooltipModule,
    HealthHistoryItemIconComponent,
    TextWithShowMoreComponent,
    SvgIconComponent,
    HealthHistoryItemProvisionalStatusIconComponent,
    PatientAlertsDateIndicatorComponent,
  ],
  templateUrl: './patient-alerts-item-details.component.html',
  styleUrl: './patient-alerts-item-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientAlertsItemDetailsComponent {
  private readonly store = inject(Store);
  private readonly provisionalLocksEditing = this.store.selectSignal(selectProvisionalLocksEditing);
  protected readonly isEaglesoftPms = this.store.selectSignal(selectIsEaglesoftPms);

  public readonly patientAlertsItem = input.required<PatientAlertV2>();
  public readonly hasEditButton = input<boolean>(true);
  public readonly lineClampRows = input<number>(DEFAULT_PATIENT_ALERT_LINE_CLAMP_ROWS);
  public readonly editPatientAlertEnabled = input<boolean>(true);
  public editButtonClicked = output<void>();

  public readonly isNotReady = computed(() => {
    return !!this.patientAlertsItem().provisionalStatus && this.patientAlertsItem().provisionalStatus !== ProvisionalStatus.READY;
  });
  public readonly isUnderDeletion = computed(() => {
    return this.patientAlertsItem().provisionalStatus === ProvisionalStatus.DELETING;
  });
  public readonly isEditDisabled = computed(() => {
    return (
      isLockedByProvisional(this.patientAlertsItem().provisionalStatus, this.provisionalLocksEditing()) || !this.editPatientAlertEnabled()
    );
  });

  public readonly provisionalStatus = computed(() => {
    return this.patientAlertsItem().provisionalStatus ?? ProvisionalStatus.READY;
  });

  public onEditButtonClick(): void {
    this.editButtonClicked.emit();
  }
}
